import { render, staticRenderFns } from "./JoinOrganisation.vue?vue&type=template&id=0087a342&"
import script from "./JoinOrganisation.vue?vue&type=script&lang=js&"
export * from "./JoinOrganisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports